import React from "react"
import { CustomerDescriptionBase } from "./CustomerDescriptionBase"
import { useFiltersContext } from "../GlobalFilter/context/filtersContext"
import { DateInterval } from "../PhronesisCalendar/PhronesisCalendar.utils"

interface CustomerDescriptionProps {
	dateInterval: DateInterval
}

const CustomerDescription: React.FC<CustomerDescriptionProps> = (props) => {
	const { dateInterval } = props
	const { filters } = useFiltersContext()

	return (
		<CustomerDescriptionBase dateInterval={dateInterval} filters={filters} />
	)
}

export default CustomerDescription
